import * as FPAIConstants from './constants';

export function initiateFamilyPlanInviteeFlow({ familyPlanInviteToken }) {
  return {
    type: FPAIConstants.Actions.INITIATE_FAMILY_PLAN_INVITEE_FLOW,
    data: {
      token: familyPlanInviteToken,
    },
  };
}

export function setFamilyPlanInviteCode({ familyPlanInviteToken }) {
  return {
    type: FPAIConstants.Actions.SET_FAMILY_PLAN_INVITE_CODE,
    data: {
      token: familyPlanInviteToken,
    },
  };
}

export function clearFamilyPlanInviteeFlow() {
  return setFamilyPlanInviteCode({ familyPlanInviteToken: null });
}

export function familyChildContinueClicked() {
  return {
    type: FPAIConstants.Actions.FAMILY_CHILD_CONTINUE_CLICKED,
  };
}
